<template>
  <div
    class="notification2"
    @dragover.prevent="highlight"
    @dragleave.prevent="stophighlight"
    @dragend.prevent="stophighlight"
    @drop.prevent="dropped"
    :class="{ highlighted: ishover }"
  >
    <div class="stickyTitle" v-if="noaccess">
      <div class="firstPart">
        <p>{{ name }}:</p>
      </div>
      <span>
        <b-input
          is-inverted
          placeholder="Search..."
          type="search"
          icon="magnify"
          v-model="value"
          size="is-small"
        ></b-input>
      </span>
    </div>
    <div v-else>
      <p>{{ name }}:</p>
    </div>
    <div class="notification3" v-if="claims != null && claims.length > 0">
      <pill-item v-for="claim in claims" :key="claim.identifier" :claim="claim"></pill-item>
    </div>

    <div class="help" v-else>
      De gebruiker heeft op geen enkel project {{ name }}. <strong>Sleep</strong> een project naar dit veld of druk op
      de <strong>Voeg Toe</strong> knop.
    </div>
  </div>
</template>

<script>
import PillItem from './PillItem'

export default {
  components: {
    PillItem
  },

  props: ['claims', 'name', 'level', 'noaccess', 'value'],
  data() {
    return {
      ishover: false
    }
  },
  watch: {
    value: function(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dropped(e) {
      this.ishover = false
      const item = JSON.parse(e.dataTransfer.getData('data'))
      const targetLevel = this.level
      let oldClaimLevel = null
      if (item.level) {
        oldClaimLevel = item.level
      } else {
        oldClaimLevel = 'noAccess'
      }
      if (targetLevel != null && targetLevel != oldClaimLevel) {
        this.$emit('dragged', { targetLevel, item })
        console.log('%cClaim on project added or changed', 'color: yellow')
      } else if (targetLevel == oldClaimLevel) {
        console.log('%cItem is dropped in the same container', 'color: yellow')
      } else {
        console.error('dropcontainer not found')
      }
    },

    highlight(e) {
      this.ishover = true
    },
    stophighlight(e) {
      this.ishover = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/main.scss';
.highlighted {
  box-shadow: 0 0 10px 1px rgba($fsdyellow, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/ClaimContainer.vue